import { FileUploadActions, ErrorActions } from 'common/constants/actions';

const initialState = {
  file_uploads: [],
  pending: false,
  created: false,
};

export default function FileUpload(state = initialState, action) {
  switch (action.type) {
    case FileUploadActions.START:
      return {
        ...state,
        pending: true,
      };

    case FileUploadActions.GET_ALL:
      return {
        ...state,
        file_uploads: action.payload,
        pending: false,
        created: false,
      };

    case FileUploadActions.FETCH:
      return {
        ...state,
        [action.payload.id]: action.payload,
        pending: false,
        created: false,
      };

    case FileUploadActions.CLEAR_CREATED:
      return {
        ...state,
        created: false,
      };

    case FileUploadActions.EDIT:
      return {
        ...state,
        [action.payload.id]: action.payload,
        pending: false,
        created: false,
      };

    case FileUploadActions.DELETE:
      return {
        ...state,
        file_uploads: state.file_uploads.filter(row => row.id !== action.payload.id),
      };

    case FileUploadActions.ADD:
      return {
        ...state,
        created: action.payload,
        file_uploads: [...state.file_uploads, action.payload],
      };

    case FileUploadActions.CLEAR:
      return {
        ...state,
        file_uploads: [],
        created: false,
      };

    case ErrorActions.CLEAR_ALL:
      return {
        ...state,
        file_uploads: [],
        created: false,
      };

    default:
      return state;
  }
}
